//@flow
import React from 'react';
import {Grid, Typography} from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';

type ImageResponsive = {
  desktop: string,
  mobile: string,
};

export type Props = {
  title: string,
  image: string | ImageResponsive,
  contentBg?: string,
};

const useStyles = makeStyles(theme => ({
  root: {
    height: '70%',
    [theme.breakpoints.up('md')]: {
      height: '85%',
    },
  },
  title: {
    width: '100%',
    textAlign: 'start',
    color: 'white',
    fontWeight: 600,
    fontSize: 28,
    [theme.breakpoints.up('sm')]: {
      fontSize: 34,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 38,
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: 42,
    },
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    width: '100%',
    height: '100%',
    aspectRatio: '1/1',
    objectFit: 'contain',
    maxWidth: 270,
    [theme.breakpoints.up('sm')]: {
      maxWidth: 300,
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: 350,
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 480,
    },
  },
}));

export default function ContentItem(props: Props) {
  const {title, image} = props;

  const classes = useStyles();

  // const hasImageResponsive = typeof image === 'object';

  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} sm={4} md={5}>
        <Typography variant="h4" className={classes.title}>
          {title}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={8} md={7} className={classes.imageContainer}>
        {typeof image === 'object' ? (
          <picture>
            <source media="(max-width: 768px)" srcset={image.mobile} />
            <img className={classes.image} src={image.desktop} alt={title} />
          </picture>
        ) : (
          <img className={classes.image} src={image} alt={title} />
        )}
      </Grid>
    </Grid>
  );
}
